import type { ReceiptTemplate } from '../schema';

export const nikeTemplate: ReceiptTemplate = {
  id: 'nike',
  name: 'Nike Receipt',
  brand: 'NIKE',
  description: 'Athletic retail receipt template inspired by Nike stores',
  settings: {
    width: 290,
    font: 'Courier New',
    fontSize: 11,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#111111',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'nike-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/nike.png',
        logoData: '',
        logoWidth: 80,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 28,
        addressLines: [
          'Nike NYC',
          '650 Fifth Avenue',
          'New York, NY 10019',
          '(212) 974-6453',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'nike-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'nike-trans', label: 'Transaction #', value: 'NK-093025-7834' },
          { id: 'nike-date', label: 'Date', value: '09/30/2025' },
          { id: 'nike-time', label: 'Time', value: '1:47 PM' },
          { id: 'nike-athlete', label: 'Athlete', value: 'Jordan M.' },
        ],
        column2: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nike-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        quantityPosition: 'left',
        showHeader: true,
        showHeaderDivider: true,
        headerLabels: {
          quantity: 'Qty',
          item: 'Product',
          amount: 'Price',
        },
        items: [
          { id: 'nike-item-1', quantity: '1', name: 'Air Jordan 1 Retro High', price: '$180.00' },
          { id: 'nike-item-2', quantity: '1', name: 'Nike Dri-FIT Tee', price: '$35.00' },
          { id: 'nike-item-3', quantity: '1', name: 'Nike Elite Socks 3-Pack', price: '$22.00' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nike-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'nike-subtotal', label: 'Subtotal', value: '237.00', isBold: false, isLarge: false },
          { id: 'nike-member', label: 'Member Discount', value: '-23.70', isBold: false, isLarge: false },
          { id: 'nike-tax', label: 'Tax', value: '18.94', isBold: false, isLarge: false },
          { id: 'nike-total', label: 'TOTAL', value: '232.24', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 30,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'nike-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'nike-method', label: 'Payment', value: 'Apple Pay' },
          { id: 'nike-card', label: 'Card', value: 'Visa ****9012' },
          { id: 'nike-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [
          { id: 'nike-cash', label: 'Cash', value: '$250.00' },
          { id: 'nike-change', label: 'Change', value: '$17.76' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nike-member',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '★ NIKE MEMBER ★\nYou saved $23.70 today!\n\nPoints Earned: 232\nTotal Points: 4,521',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nike-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns within 60 days with receipt.\nJust Do It.\n\nnike.com',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nike-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'NK0930257834',
        showValue: true,
        width: 1.4,
        height: 45,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};
